{
	"Rules_Validation_MustBeANumber": "Must be a number",
	"Rules_Validation_MustBeAnInteger": "Must be a whole number",
	"Rules_Validation_MustBeGreaterThanZero": "Must be greater than zero",
	"Rules_Validation_MustBeUnderLimit": "Must be less than {}",
	"Rules_Validation_EmailMustBeValid": "Email must be valid",
	"Rules_Validation_MustBeLessThanMaxSafeInteger": "Greater than the maximum value allowed",
	"Rules_Validation_MustBeLessThanLimit": "Must be less than {}",
	"Rules_Validation_MustMatch": "Must match",
	"Rules_Validation_MinLength": "Must be at least {} characters long",
	"Rules_Validation_MaxLength": "Must be at most {} characters long",
	"Rules_Validation_MaxWordLength": "Each word must be at most {} characters long",
	"Rules_Validation_ValidUrl": "Must be a valid URL",
	"Rules_Validate_Empty": "This field is required",
	"Rules_Numbers_MaxSafeInteger": "the maximum integer value",
	"Rules_Validation_IncorrectPattern": "The provided value is not valid",
	"Rules_Validation_Unique": "The value must be unique",
	"Rules_Validation_ContentType": "The content type must be one of the following: {}",
	"Rules_Validation_MustBeInRange": "Must be between {} and {}",
	"NAME": "RulesLanguage"
}